import { notification } from 'antd';
import { COLORS } from 'styles/theme/colors';

const DEFAULT_NOTIFICATION_PLACEMENT = 'bottomLeft';
const DEFAULT_NOTIFICATION_DURATION = 0;
const DEFAULT_SUCCESS_MESSAGE = 'Success!';
const DEFAULT_ERROR_MESSAGE = "Oops, that didn't work";

export function notifySuccess(message = DEFAULT_SUCCESS_MESSAGE) {
  notification.open({
    message: message,
    placement: DEFAULT_NOTIFICATION_PLACEMENT,
    duration: DEFAULT_NOTIFICATION_DURATION,
  });
}

export function notifyError(message = DEFAULT_ERROR_MESSAGE) {
  notification.open({
    message: message,
    placement: DEFAULT_NOTIFICATION_PLACEMENT,
    duration: DEFAULT_NOTIFICATION_DURATION,
    style: { backgroundColor: COLORS.primaryErrorText },
  });
}
